import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Counter"] */ "/app/src/sections/scans/hero/counter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/scans/hero/dynamicbg.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/scans/sub-nav/SubNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Video"] */ "/app/src/sections/scans/video/index.tsx");
